import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/kho-y-tuong/")({});
